import { Skeleton } from '@/components/ui/skeleton';

export function ProductTabsSkeleton() {
    return (
        <div className="gap-8 max-w-screen-2xl mx-auto">
            <div className="flex gap-3 max-w-full overflow-x-auto scrollbar-hide">
                <Skeleton className="h-9 w-28 shrink-0 rounded-full" />
                <Skeleton className="h-9 w-24 shrink-0 rounded-full" />
                <Skeleton className="h-9 w-32 shrink-0 rounded-full" />
            </div>
            <div className="px-4 pt-6 space-y-3">
                <Skeleton className="h-4 w-full max-w-md" />
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-32 w-full" />
            </div>
        </div>
    );
}
